import { isDateTimeAfterNowWithBuffer } from '@/utils/date' 
import { Operations } from '@/api/business/cockpit/type'
import {  parseISO, addHours, addMinutes } from 'date-fns'

export const validadeStatusCardOperation = (operation : Operations, operations: Operations[] ,index : number) => {
    if(operations[0].NF.DD_PROCESSO_HUB){
        if(operations.length - 1 == index ){
            return 'bg-gray-500 opacity-40'
        }
    }

    if(operation.NF.DD_NF_RECEBIDA == 1) return 'bg-completed'
    
    if(!operation.NF.DD_DOC) return 'bg-gray-500'
    
    if(operation.NF.SK_IMPEDITIVO != 1) return 'bg-warning'


    if(!operation.DD_CTE){
        if(!isDateTimeAfterNowWithBuffer(operation.NF.DT_EMISSAO, operation.DD_TEMPO_OPERACAO)) return 'bg-timeout'
    } else if(operation.NF.DT_RECONHECIMENTO) { 
        if(!isDateTimeAfterNowWithBuffer(operation.NF.DT_RECONHECIMENTO, operation.DD_TEMPO_OPERACAO)) return 'bg-timeout'
    } else {
        return 'bg-waitingknowledge'
    }
     
    return 'bg-intransport'
}

export const calcTime = (operation : Operations, operations: Operations[] ,index : number ) => { 
    if(operations[0].NF.DD_PROCESSO_HUB){
        if(operations.length - 1 == index ){
            return 'Não aplicável'
        }
    }

    if(operation.NF.DD_NF_RECEBIDA) return 'Concluido'

    let date = new Date()

    if (operation.DD_CTE) {
        if(!operation.NF.DT_RECONHECIMENTO) return 'Aguardando'

        date = parseISO(operation.NF.DT_RECONHECIMENTO);
    } else {
        date = parseISO(operation.NF.DT_EMISSAO);
    } 
    
    const [hours, minutes] = operation.DD_TEMPO_OPERACAO.split(':').map(Number); 

    let dateWithBuffer = addHours(date,hours);
    dateWithBuffer = addMinutes(dateWithBuffer, minutes);  

    const diferencaMs = dateWithBuffer.getTime() - new Date().getTime();

    const passou = diferencaMs < 0;

    // Converter diferença absoluta para horas e minutos
    const diferencaAbsoluta = Math.abs(diferencaMs);
    const diferencaHoras = Math.floor(diferencaAbsoluta / (1000 * 60 * 60));
    const diferencaMinutos = Math.floor((diferencaAbsoluta / (1000 * 60)) % 60);
  
    // Formatar o tempo no formato HH:MM
    const horasFormatadas = String(diferencaHoras).padStart(2, '0');
    const minutosFormatados = String(diferencaMinutos).padStart(2, '0');
    const tempoFormatado = `${horasFormatadas}:${minutosFormatados}`;
  
    // Retornar a mensagem apropriada
    return passou ? `Passou ${tempoFormatado}` : `Resta ${tempoFormatado}`; 

} 